import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Container } from 'reactstrap';
import { downloadBlob } from '../../../utils/requests';
import DropSection from '../DropSection';
import styles from './styles.scss';

const FileUpload = ({ files = [], maxFiles, accept = '.pdf', onUploadFile, onRemoveFile }) => {
  const hasFiles = files && files.length;
  return (
    <Row className={`mx-0 pl-1 py-3 ${styles.uploadWrapper}`}>
      <Col>
        <Choose>
          <When condition={files.length < maxFiles}>
            <DropSection key="dropsection" accept={accept} onDrop={onUploadFile} />
          </When>
          <Otherwise>
            <div className="d-table w-100 h-100 text-center">
              <div className={`d-table-cell ${styles.maxAttachmentsContainer}`}>
                {`Only ${maxFiles} ${maxFiles === 1 ? 'file' : 'files'} can be attached`}
              </div>
            </div>
          </Otherwise>
        </Choose>
      </Col>
      <Col>
        <Choose>
          <When condition={hasFiles}>
            <p>Attached {maxFiles === 1 ? 'file' : 'files'}:</p>
            <Container className={`${styles.attachmentContainer}`}>
              {files.map((file) => (
                <Row className={`p-3 ${styles.attachmentRow}`} key={file.link}>
                  <Col>
                    <Choose>
                      <When condition={file.file}>
                        <a href={file.link} target="_blank" rel="noopener noreferrer">
                          {file.name}
                        </a>
                      </When>
                      <Otherwise>
                        <a
                          href="#"
                          onClick={() => {
                            downloadBlob(`${file.link}/Download`).then((blob) => {
                              const link = document.createElement('a');
                              link.href = window.URL.createObjectURL(blob);
                              link.target = '_blank';
                              link.type = 'hidden';
                              document.body.appendChild(link);
                              link.click();
                              link.remove();
                            });
                          }}
                        >
                          {file.name}
                        </a>
                      </Otherwise>
                    </Choose>
                  </Col>
                  <Col className="text-right">
                    <i className={`fa fa-times ml-2 ${styles.deleteIcon}`} onClick={() => onRemoveFile(file.link)} />
                  </Col>
                </Row>
              ))}
            </Container>
          </When>
          <Otherwise>
            <div className="d-table w-100 h-100 text-center">
              <div className={`d-table-cell ${styles.noAttachmentsContainer}`}>
                <i className={`fa fa-file-o mb-2 ${styles.fileIcon} ${styles.inactive}`} />
                <br />
                <span className={styles.inactive}>No files attached</span>
              </div>
            </div>
          </Otherwise>
        </Choose>
      </Col>
    </Row>
  );
};

FileUpload.propTypes = {
  files: PropTypes.array,
  maxFiles: PropTypes.number,
  accept: PropTypes.string,
  onUploadFile: PropTypes.func,
  onRemoveFile: PropTypes.func,
  downloadFile: PropTypes.func,
};

export default FileUpload;



// WEBPACK FOOTER //
// src/components/shared/FileUpload/index.jsx